import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import VisitorPass from "@/components/VisitorPass";
import { Loader2 } from "lucide-react";

export default function PassView() {
  const { visitorId } = useParams();
  const [pass, setPass] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    api.get(`/pass/${visitorId}`).then((r) => setPass(r.data)).catch(() => setErr(true));
  }, [visitorId]);

  if (err) return <div className="min-h-screen flex items-center justify-center text-white" style={{ background: "#081226" }}>Pass not found.</div>;
  if (!pass) return <div className="min-h-screen flex items-center justify-center" style={{ background: "#081226" }}><Loader2 className="animate-spin text-[#E8752A]" /></div>;
  return <VisitorPass pass={pass} />;
}
